import { SVGProps } from 'react';

const SupportIcon = ({
  height = '24px',
  width = '24px',
  strokeWidth = '2',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 64 64'
    aria-labelledby='title'
    {...props}
  >
    <path
      data-name='layer2'
      d='M35.9 51H2s0-7 9.4-8.8S20 38.6 20 37v-2a14.2 14.2 0 0 1-4-7c-2.5 0-4-3-4-6 0-.8 0-4 2-4-1.6-6.4-.4-13 4-13 10.4-7 25-1.5 20 13 2 0 2 3.2 2 4 0 3-1.5 6-4 6a14.1 14.1 0 0 1-4 7v2a3.7 3.7 0 0 0 2.5 3.4 38.7 38.7 0 0 0 6.2 1.6'
      fill='none'
      strokeMiterlimit='10'
      strokeWidth={strokeWidth}
      strokeLinejoin='round'
      strokeLinecap='round'
    ></path>
    <path
      data-name='layer1'
      fill='none'
      strokeMiterlimit='10'
      strokeWidth={strokeWidth}
      d='M30 62l16-30 16 30H30zm16-18v6'
      strokeLinejoin='round'
      strokeLinecap='round'
    ></path>
    <circle
      data-name='layer1'
      cx='46'
      cy='55'
      r='1'
      fill='none'
      strokeMiterlimit='10'
      strokeWidth={strokeWidth}
      strokeLinejoin='round'
      strokeLinecap='round'
    ></circle>
  </svg>
);

export default SupportIcon;
